module.exports = "/_next/static/images/db643a382b07326a313e4ae029029811-nu-card-xs@3x.jpg.webp";